import StyledAccessibleSmallModal from './StyledAccessibleSmallModal'

const AccessibleSmallModal = props => (<StyledAccessibleSmallModal {...props} />)

export default AccessibleSmallModal
